import { Box, Text, Flex, ThemeIcon, Divider } from "@mantine/core";
import { IconCircleFilled } from "@tabler/icons-react";
import React, { FC, ReactNode } from "react";

type Props = {
  currentStatusContents: ReactNode;
  statusContents: ReactNode;
};

export const StatusDisplay: FC<Props> = (props: Props) => {
  const { currentStatusContents, statusContents } = props;
  return (
    <>
      <Box mb={32}>{currentStatusContents}</Box>

      <Box mb={32}>
        <Text fz="xl" fw={700} mb={8}>
          サービス稼働状況（直近12時間）
        </Text>
        <Divider my="sm" />
        <Flex mih={40} justify={"Center"} columnGap={4} mt={16} mb={16}>
          {statusContents}
        </Flex>
        <Flex columnGap={4}>
          <ThemeIcon
            size={"sm"}
            style={{ color: "#21AF63", backgroundColor: "#f3f3f3" }}
          >
            <IconCircleFilled />
          </ThemeIcon>
          <Text mr={10}>正常</Text>
          <ThemeIcon
            size={"sm"}
            style={{ color: "orange", backgroundColor: "#f3f3f3" }}
          >
            <IconCircleFilled />
          </ThemeIcon>
          <Text mr={10}>応答遅延</Text>
          <ThemeIcon
            size={"sm"}
            style={{ color: "red", backgroundColor: "#f3f3f3" }}
          >
            <IconCircleFilled />
          </ThemeIcon>
          <Text mr={10}>大幅な応答遅延</Text>
          <ThemeIcon
            size={"sm"}
            style={{ color: "#4169E1", backgroundColor: "#f3f3f3" }}
          >
            <IconCircleFilled />
          </ThemeIcon>
          <Text>メンテナンス</Text>
        </Flex>
      </Box>
    </>
  );
};
